export enum NotificationType {
  TEXT = 'TEXT',
  SMS = 'SMS',
  EMAIL = 'EMAIL',
  VOE_RESPONSE = 'VOE_RESPONSE',
  ORDER_UPDATE = 'ORDER_UPDATE',
  NOTE = 'NOTE',
  TRAINING = 'TRAINING',
  TASK = 'TASK',
}
